const DROPDOWN_SELECTOR = ".header-desktop-navbar__dropdown";
const DROPDOWN_CONTENT_SELECTOR = ".header-desktop-navbar__dropdown-content";
const ACTIVE_CLASS = "is-visible";
const TOGGLE_DELAY = 200;

document.addEventListener("DOMContentLoaded", () => {
  const dropdownNodes =
    document.querySelectorAll<HTMLDivElement>(DROPDOWN_SELECTOR);

  const dropdowns = Array.from(dropdownNodes).map((root) => ({
    root,
    content: root.querySelector<HTMLDivElement>(DROPDOWN_CONTENT_SELECTOR)!,
  }));

  let openTimer: ReturnType<typeof setTimeout> | null = null;
  let closeTimer: ReturnType<typeof setTimeout> | null = null;

  const open = (item: (typeof dropdowns)[number]) => {
    openTimer = setTimeout(() => {
      if (item.root.matches(":hover") || item.content.matches(":hover")) {
        item.content.classList.add(ACTIVE_CLASS);
      }
    }, TOGGLE_DELAY);
  };

  const close = (item: (typeof dropdowns)[number]) => {
    closeTimer = setTimeout(() => {
      if (item.root.matches(":hover") || item.content.matches(":hover")) {
        clearTimeout(openTimer);
        return;
      }

      item.content.classList.remove(ACTIVE_CLASS);
      clearTimeout(closeTimer);
    }, TOGGLE_DELAY);
  };

  dropdowns.forEach((item) => {
    item.root.addEventListener("pointerenter", () => open(item));
    item.root.addEventListener("pointerleave", () => close(item));
  });
});
